import React, { useEffect, useState } from 'react';

interface Metrics {
  totalUsers: number;
  activeUsers: number;
  requests: number;
  errors: number;
}

function Dashboard() {
  const [metrics, setMetrics] = useState<Metrics | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/dashboard')
      .then(res => res.json())
      .then(data => {
        setMetrics(data.metrics);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch dashboard data:', err);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Loading dashboard...</div>;

  return (
    <div className="dashboard">
      <h2>Dashboard</h2>
      
      <div className="dashboard-grid">
        <div className="metric-card">
          <h3>Total Users</h3>
          <div className="value">{metrics?.totalUsers || 0}</div>
        </div>
        
        <div className="metric-card">
          <h3>Active Users</h3>
          <div className="value">{metrics?.activeUsers || 0}</div>
        </div>
        
        <div className="metric-card">
          <h3>API Requests</h3>
          <div className="value">{metrics?.requests || 0}</div>
        </div>
        
        <div className="metric-card">
          <h3>Errors</h3>
          <div className="value">{metrics?.errors || 0}</div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;